import util from '../util'

let controller = 'ParceiroHeaders'
export default Object.assign({}, util.GetCrud(controller, null))